import { render } from "./UpdateSection.vue?vue&type=template&id=8ca8fce8"
import script from "./UpdateSection.vue?vue&type=script&lang=js"
export * from "./UpdateSection.vue?vue&type=script&lang=js"

import "./UpdateSection.vue?vue&type=style&index=0&id=8ca8fce8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__